module.exports = {
  Beginner:'Beginner',
  BeginnerTips1:'Watch and learn Pinyin sounds and tones.',
  BeginnerTips2:'PinYin Sounds & Tones',
  Intermediate:'Intermediate',
  IntermediateTips1:'Improve speaking pronunciation and grammar skills.',
  Advanced:'Advanced',
  AdvancedTips1:'Boost fluency, expression and natural speaking skills.',
  AdvancedTips2:'Speaking Video List',
  '300 Sentences':'300 Sentences',
  '300SentencesTips1':'300 useful Chinese sentences for life, study, and travel.',
  'Basic Challenge':'Basic Challenge',
  'Basic Chinese Challenge':'Basic Chinese Challenge',
  'BasicChallengeTips1':'Test your tones pronunciation, and pinyin.',
  ChallengeTips:'Not unlocked yet',
  'Learn':'Learn',
  'Watch':'Watch',
  'Recommended':'Recommended',
  NoGameList:'No Basic Challenge!',
  "Sample Sentence":"Sample Sentence",
  "Ques No":"Ques No",
  "Correct Answer":"Correct Answer",
  "Your Answer":"Your Answer",
  "Your Result":"Your Result",
  "Final Result":"Final Result",
  "Previous":"Previous",
  "Next":"Next",
  "Try Again":"Try Again",
  "Next Level":"Next Level",
  "Profile":"Profile",
  "Current Challenge Level":"Current Challenge Level",
  language:"Language Select",
  Unsucscribe:"Unsubscribe",
  back:"Back",
  Replay:"Repaly",
  English:"English",
  loginTips:"Enter a phone number",
  subscribe:'Subscribe',
  FAQ:"FAQ",
  TC:"T&C",
  getCode:"Resend",
  register:"Register",
  phoneNumber:"Phone Number",
  Daily:"Daily",
  Weekly:"Weekly",
  pleaseWait:"Please wait",
  loading:"loading",
  Submit:"Submit",
  Confirm:"Confirm",
  OK:"OK",
  change:"Change",
  Myanmar:"Myanmar",
    Copyright:"© 2025 All Rights Reserved.",
    select_level:"Start Review",
  select_level_tip1:"Start Now",
  select_level_tip2:"Skip this",
    level_1_title:"Your Journey Starts Here",
    level_1_tip:"You're at the Beginner Level.Perfect for building a strong foundationin the language.",
    level_1_btn:"Begin the Journey",
  level_2_title:"Great Progress!",
  level_2_tip:"You've reached the Intermediate LevelTime to improve conversations,grammar, and fluency.",
  level_2_btn:"Keep Going",
  level_3_title:"IMpressive Skills!",
  level_3_tip:"You're at the Advanced Level.Get ready to master native-like speakingand comprehension.",
  level_3_btn:"Start Mastery",
  level_again:"Re-rating",
  current_level:"Current Level",
  Re_admission:"Re-admission Testing",
  Re_testing:"Re-Testing",
  Intermediate_tips:"Please complete the Beginner course first",
  Advanced_tips:"Please complete the Intermediate course first",
  in_process:"In Process",
  no_start:"Not Started",
  finished:"Finished",
  books:"Books",
  guidance:"GUIDANCE",
  test_level_tip:"Take a short review to know your language level.",
  beginner_guidance_title:"Welcome to the Beginner class",
  beginner_guidance_tip:"We'll start with Pinyin and guide you step by step.Once you complete the Pinyin course,more exciting lessons will be automatically unlocked for you!" ,
  intermediate_guidance_title:"Welcome to the Intermediate class",
  intermediate_guidance_tip:"Don't worry, you can take it step by step.By completing all the lessons, you'll unlock even more interesting content. Keep it up!" ,
  advance_guidance_title:"Welcome to the advance class",
  advance_guidance_tip:"We've unlocked all the courses for you.Enjoy them to the fullest!" ,
  book_title:"Books Suitable" ,
  book_tip:"Books suitable for all levels, designed to be easy to learn and enjoy!" ,
  load_book:"Loading book content...",
  load_book_failed:"Failed to load book content",
  reload:"Reload",
  copyLink:"copyLink",
  downTips1:'Please copy the link into browser and download.',
  CopySucceeded:'Copy Succeeded',
  CopyFailed:'Copy Failed',
  sub_type:"Subscription Type",
  test_tip:"Please click on the correct answer",
  English_tip:"English",
  Background_Music:"Background Music",
  loadMore2:"no more books",
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js